CustomTC.define('main-common',['modules/events', 'modules/player', 'modules/extension/extension', 'modules/util', 'modules/logger', 'modules/options', 'modules/core'], function(events, player, extension, util, logger, options, core) {
    return {
        init: function(config) {
            if (config.exts) {
                for (ext in config.exts) {
                    extension.init(ext, config.exts[ext]);
                }
            }
            if (config.debug == 1) {
                this.enableDebugLogs();
            }
            // logger init
            logger.init();
            // init player
            player.init(config);
            return true;
        },
        Player: player,
        Fallback: {
            videoEnded: function() {
                player.videoEnded();
            }
        },
        // enable logs
        enableDebugLogs: function() {
            TouchCast.enableDebugLogs();
            logger.setLogs(true);
            logger.init();
            return;
        },
        // disable logs
        disableDebugLogs: function() {
            logger.setLogs(false)
            logger.init();
            return;
        },
        Event: events
    }
});
